import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IValetType } from '../interfaces/valet-type';
import { IValetTypeFilter } from '../interfaces/valet-type-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class ValetTypeService extends EditService<IValetType, IValetTypeFilter> {
  url = '/api/valettypes';
  entityTitle = 'ValetType';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
